// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app__2hfFH","board__container":"App__board__container__3wwHq","board":"App__board__351xE"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 18
// module chunks = 0